import { render } from "./QuestionOne.vue?vue&type=template&id=9d86a1c6&scoped=true"
import script from "./QuestionOne.vue?vue&type=script&lang=js"
export * from "./QuestionOne.vue?vue&type=script&lang=js"

import "./QuestionOne.vue?vue&type=style&index=0&id=9d86a1c6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d86a1c6"]])

export default __exports__